import { AxiosResponse } from "axios";
import { ApiTags } from ".";
import { HttpMethods } from "../httpMethods";
import { Controllers, GeneralRoutes, TagsApiRoutes } from "src/utils/constants";
import { Tag } from "src/types/tag";
import { BaseService } from "../baseService";

export class TagService extends BaseService implements ApiTags {
    async getTags(urlParams: string): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Get, Controllers.Tag, TagsApiRoutes.Tags, urlParams);
    }

    async deleteTags(data: string[]): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.Tag, GeneralRoutes.Delete, null, data);
    }

    async getTagById(tagId: string): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Get, Controllers.Tag, '', `${tagId}`);
    }

    async createTag(tag: Tag): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.Tag, GeneralRoutes.Create, null, tag);
    }

    async updateTag(tag: Tag): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.Tag, GeneralRoutes.Update, null, tag);
    }
}
